import { createFileRoute } from '@tanstack/react-router';

import { CallOffForm } from '~/modules/callOff/form';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from '../../-routeParams';

const title = i18n.t(($) => $.form.pageTitle.edit, { ns: 'callOff' });

export const Route = createFileRoute(
  '/(main)/demand/call-offs/$callOffId/edit/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/demand/call-offs/$callOffId/edit/',
    ...routeParams,
  }),
  component: CallOffForm,
  head: () => getRouteHead(title, 'Bearbeite deinen Abruf in VESTIGAS'),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const DEMAND_CALLOFF_EDIT = buildRouteExport({
  Route,
  ...routeParams,
});
